import { animate, keyframes, query, stagger, style, transition, trigger } from '@angular/animations';

export const buttonSpinnerAnimation = trigger('buttonSpinner', [
    transition('* => *', [
        query('.punto-animado', [
            stagger('80ms', [
                animate('0.5s ease-in-out', keyframes([
                    // 0%: Estado inicial abajo usando el tamaño base circular
                    style({ transform: 'translateY(0)', height: 'var(--spinner-size-base)', offset: 0 }),

                    // 35%: Se estira hasta la altura máxima definida por CSS según el tamaño del botón
                    style({ transform: 'translateY(var(--spinner-jump-stretch))', height: 'var(--spinner-size-max)', offset: 0.35 }),

                    // 65%: Alcanza el punto más alto y recupera su forma circular arriba
                    style({ transform: 'translateY(var(--spinner-jump-max))', height: 'var(--spinner-size-base)', offset: 0.65 }),

                    // 100%: Regresa suavemente a la base abajo
                    style({ transform: 'translateY(0)', height: 'var(--spinner-size-base)', offset: 1 })
                ]))
            ])
        ], { optional: true })
    ])
]);
